const validateDate = (dateString) => {
    // Attempt to create a Date object from the input string
    const parsedDate = new Date(dateString);
  
    // Check if the parsed date is valid
    if (isNaN(parsedDate.getTime())) {
      return false; // Invalid date
    }
  
    // Additional custom validation logic if needed
    // For example, you can check if the date is within a specific range.
  
    return true; // Valid date
  };

  export default validateDate;